import contractAbi from "./contractAbi.json";
import { contractAddress } from "./environment";

import { readContract, writeContract } from "wagmi/actions";
import { waitForTransaction } from "@wagmi/core";

export const contractReadFunction = async (functionName, args) => {
  const data = await readContract({
    address: contractAddress,
    abi: contractAbi,
    functionName,
    chainId: 1,
    args,
  });
  return data;
};

/// write functions
export const contractWriteFunction = async (functionName, args) => {
  const { hash } = await writeContract({
    address: contractAddress,
    abi: contractAbi,
    functionName,
    chainId: 1,
    args,
  });
  const receipt = await waitForTransaction({ hash });
  return receipt;
};
